<div [formGroup]="workflowStatusForm" class="whole-modal">
    <div class="modal-header position-relative">
        <div class="row w-100 mt-3">
            <div class="col">
                <div class="d-flex justify-content-start align-items-center h-100">
                    <h3 class="activity_title d-flex overflow-hidden text-nowrap align-items-center m-0">
                        Instance Name <span data-bs-toggle="tooltip" data-bs-placement="top" class="text-truncate"> {{
                            header_instanceName }} </span> Asset Type
                        <span class="text-truncate" data-bs-toggle="tooltip" data-bs-placement="top"> {{
                            header_assetType }} </span>
                        <div>
                            Activity Pack Type<span class="text-truncate" data-bs-toggle="tooltip"
                                data-bs-placement="top">{{ activityPackName }}</span>
                        </div>
                    </h3>
                </div>
            </div>
            <a class="" href="javascript:void()" (click)="ngbActiveModal.close(false)" ngbAutofocus><i
                    style="margin-top: 16px;" class="flaticon2-cross close-icon position-absolute"> </i></a>
        </div>
    </div>
    <div class="modal-body output-lable" style="max-height: 400px">
        <div class="row">
            <div class="activity_details">
                <div class="row">
                    <!-- <div class="d-flex align-items-center"> -->

                    <div class="col-md-6">
                        <div class="row mb-3">
                            <div class="col-md-3">
                                <h3 class="work_flow_label">Name</h3>
                            </div>
                            <div class="col-md-9">
                                <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                                    <input type="text" *ngIf="workFlowStatus !== null" matInput placeholder="Name"
                                        formControlName="name" value="{{ workFlowStatus.activityPackTypeStatus.name }}"
                                        minlength="4" required (keypress)="onKeyPress($event)"
                                        (paste)="onKeyPress($event)" />
                                    <input type="text" *ngIf="workFlowStatus == null" matInput placeholder="Name"
                                        formControlName="name" value="" minlength="4" required
                                        (keypress)="onKeyPress($event)" (paste)="onKeyPress($event)" />
                                </mat-form-field>
                                <span class="text-danger"
                                    *ngIf="workflowStatusForm.get('name').hasError('duplicateName')">Duplicate name not
                                    accepted!</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row mb-3">
                            <div class="col-md-3">
                                <h3 class="work_flow_label">Function</h3>
                            </div>
                            <div class="col-md-9">
                                <mat-select name="asset_type" class="dropdown-wrapper" panelClass="dropdown-wrapper"
                                    placeholder="Select Instance type" formControlName="functionVal">
                                    <mat-option [value]="func.key"
                                        *ngFor="let func of activitypacktypestatusfunctionsList">
                                        {{ func.value }}
                                    </mat-option>
                                </mat-select>

                                <span class="text-danger"
                                    *ngIf="workflowStatusForm.get('functionVal').hasError('required')"> This feild is
                                    required!</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12">
                <div class="schema_defination">
                    <h4>Latest Schema Definition</h4>
                    <button class="btn primary-ebtn" #tooltip="matTooltip"
                        [disabled]="workFlowStatus?.activityPackTypeStatus?.schemaVersions?.length == 50 || isSchemaAdd"
                        matTooltip="Add New Schema" (click)="addNewSchemaVersion()">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                    <mat-accordion>
                        <mat-expansion-panel *ngFor="let schema of schemaVersionList; let i = index">
                            <mat-expansion-panel-header>
                                <mat-panel-title style="width: 100%">
                                    Version {{ schema.version }}<span *ngIf="schema.schemaVersionId == null"
                                        class="text-danger">*</span><span *ngIf="schema.schema == null"
                                        class="text-danger"> - Unable To Parse
                                        JSON</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="json-editor">
                                <json-editor #editor [options]="getJsonEditorOptions(schema)"
                                    [data]="getSchemaData(schema.schemaVersionId)"></json-editor>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <mat-paginator [length]="currentPageItemLength" *ngIf="fullSchemaVersionList.length > 4"
                        [pageSize]="pageSize" (page)="pageEvent = getPaginationData($event)" #paginator>
                    </mat-paginator>
                </div>
            </div>
            <div class="col-md-12 mt-5 mb-5">
                <div class="card card-custom card-shadow">
                    <div class="card_gridTwo">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="card-status">
                                <h4>Project Type Status</h4>
                            </div>
                            <div></div>
                        </div>
                        <div class="upload_fild">
                            <div class="table_responsive">
                                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                                    <ng-container matColumnDef="statusName">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status Name</th>
                                        <td mat-cell *matCellDef="let element">
                                            <!-- {{ element.name }} -->
                                            {{ workflowStatusForm.get('name')?.value ?
                                            workflowStatusForm.get('name')?.value : 'Please enter a Name' }}
                                            <!-- <span formControlName="name"></span> -->
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="color">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Colour</th>
                                        <td mat-cell *matCellDef="let element">
                                            <!-- <span class="color_box" [style.background]="element.colour"></span> -->
                                            <dx-color-box formControlName="colour"
                                                [inputAttr]="{ 'aria-label': 'Default mode' }"></dx-color-box>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button href="javascript:void()" type="button" (click)="ngbActiveModal.close(false)"
            class="btn secondary-ebtn me-3">Cancel</button>
        <button type="button" class="btn primary-ebtn" [disabled]="checkDisable()"
            (click)="saveWorkflowStatus()">Save</button>
    </div>
</div>